<template>
  <b-tab title="Equipamentos" class="m-0 p-0">
    <div class="tab-screen-list-alt">
      <!-- :::::::::::::::::::::::::::: TABELA DE EQUIPAMENTOS :::::::::::::::::::::::::::: -->
      <b-table
        id="table-equip"
        bordered
        hover
        small
        head-variant="light"
        :per-page="perPage"
        :current-page="currentPage"
        :items="getFilterEquipamentos(filtro)"
        :fields="fields.equipamento"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)" v-b-tooltip.hover title="Imagem">
              <b-icon icon="image" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="servicos(data.item)" v-b-tooltip.hover title="Serviços">
              <b-icon icon="gear-fill" variant="warning"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
            <b-form-input
              id="eqp-filter-sgcq"
              type="search"
              size="sm"
              variant="warning"
              class="m-1 p-1"
              placeholder="Sgcq"
              v-model="filtro.sgcq"
            />
            <b-form-input
              id="eqp-filter-codigo"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Código"
              v-model="filtro.codigo"
            />
            <b-form-input id="eqp-filter-nome" type="search" size="sm" class="m-1 p-1" placeholder="Nome" v-model="filtro.nome" />
            <b-form-input
              id="eqp-filter-grupo"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Grupo"
              v-model="filtro.grupo"
            />
            <b-form-input
              id="eqp-filter-referencia"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Referência"
              v-model="filtro.referencia"
            />
            <b-button id="max-size-cliente" class="ml-1 p-1 pl-3 pr-3" variant="outline-light" @click="$refs.clienteList.call()">
              {{ filtro.cliente.nome }}
            </b-button>
          </b-form>
        </b-col>
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-button size="sm" class="ml-2 pl-2 pr-3" variant="warning" @click="imprimir()">
              <b-icon icon="printer-fill" variant="light" scale="1.1" class="mr-2" />Imprimir
            </b-button>
            <b-pagination
              class="m-1 ml-2"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="table-equip"
              limit="3"
              size="sm"
            ></b-pagination>
            <b-button size="sm" class="m-1" variant="light">
              {{ rows + " itens" }}
            </b-button>
          </b-form>
        </b-col>
      </div>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <equipamento-modal ref="editor" @showAtualizado="showAtualizado($event)" />
    <servico-list-modal ref="servicoList" />
    <equipamento-print-modal ref="printer" />
    <display-modal ref="display" :size="'sm'" />
    <cliente-list ref="clienteList" @addCliente="addCliente($event)" />
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import Equipamento from "@/models/Equipamento";
import Cliente from "@/models/Cliente";
import TableFields from "@/tools/TableFields";
import EquipamentoModal from "@/components/modals/equipamento/EquipamentoModal";
import EquipamentoPrintModal from "@/components/modals/equipamento/EquipamentoPrintModal.vue";
import DisplayModal from "@/components/modals/diversos/DisplayModal";
import ClienteListModal from "@/components/modals/cliente/ClienteListModal";
import ServicoListModal from "@/components/modals/equipamento/ServicoListModal.vue";
import Files from "@/http/files";

export default {
  name: "EquipamentoTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: {
        sgcq: "",
        codigo: "",
        nome: "",
        grupo: "",
        referencia: "",
        cliente: new Cliente(0, "Todos os Clientes", "", "", "", "", "", "", ""),
      },
      equipamento: new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", ""),
      files: new Files(this.$http),
      perPage: 50,
      currentPage: 1,
    };
  },

  components: {
    "equipamento-modal": EquipamentoModal,
    "display-modal": DisplayModal,
    "servico-list-modal": ServicoListModal,
    "equipamento-print-modal": EquipamentoPrintModal,
    "cliente-list": ClienteListModal,
  },

  computed: {
    rows() {
      return this.getFilterEquipamentos(this.filtro).length;
    },
  },

  methods: {
    adicionar() {
      this.equipamento = new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", "");
      this.$refs.editor.call(this.equipamento);
    },

    addCliente(cliente) {
      this.filtro.cliente.update(cliente);
    },

    editar(equipamento) {
      this.$refs.editor.call(equipamento);
    },

    servicos(equipamento) {
      this.$refs.servicoList.call(equipamento);
    },

    imprimir() {
      if (this.filtro.referencia != "") {
        const lista = this.getFilterEquipamentos(this.filtro);
        this.$refs.printer.call(lista);
      }
    },

    showAtualizado(equipamento) {
      this.filtro.sgcq = equipamento.sgcq;
    },

    display(equipamento) {
      this.files.downloadEquipamento(equipamento.sgcq).then((response) => this.$refs.display.call(response));
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getFilterEquipamentos } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getFilterEquipamentos,
    };
  },
};
</script>

<style lang="scss" scoped>
#eqp-filter-sgcq {
  width: 5rem;
}
#eqp-filter-codigo {
  width: 8rem;
}
#eqp-filter-nome {
  width: 20rem;
}
#eqp-filter-grupo {
  width: 10rem;
}
#eqp-filter-referencia {
  width: 12rem;
}
#max-size-cliente {
  max-width: 16rem;
  max-height: 2rem;
  overflow-x: hidden;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
